import { useState } from "react";
import EmailTemplateEditor from "@/components/EmailTemplateEditor";
import AdminSmsCard from "@/components/AdminSmsCard";
import AdminBroadcastCard from "@/components/admin/AdminBroadcastCard";
import AdminDripCard from "@/components/admin/AdminDripCard";
import { FileEdit, Send, Mail, Phone } from "lucide-react";

const SUB_TABS = [
  { key: "templates", label: "Templates", icon: FileEdit, Comp: EmailTemplateEditor },
  { key: "drip", label: "Drip schedule", icon: Mail, Comp: AdminDripCard },
  { key: "broadcast", label: "Broadcast", icon: Send, Comp: AdminBroadcastCard },
  { key: "sms", label: "SMS", icon: Phone, Comp: AdminSmsCard },
];

export default function AdminEmailsTab() {
  const [sub, setSub] = useState("templates");
  const Comp = (SUB_TABS.find((s) => s.key === sub) || SUB_TABS[0]).Comp;
  return (
    <div className="space-y-4" data-testid="admin-emails-tab">
      <div className="flex gap-1.5 flex-wrap">
        {SUB_TABS.map((s) => {
          const active = s.key === sub;
          return (
            <button
              key={s.key}
              onClick={() => setSub(s.key)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition ${active ? "bg-[#3A5A4A] text-white" : "bg-[#F3EFEA] text-[#7A736E] hover:bg-[#EBE5DF]"}`}
              data-testid={`emails-sub-${s.key}`}
            >
              <s.icon className="w-4 h-4" /> {s.label}
            </button>
          );
        })}
      </div>
      <Comp />
    </div>
  );
}
